import React from "react";
import Container from "../../components/General/Container";
import { MrWrapper, Wrapper } from "./AccessibilityStatement.styled";
import { GeneralText } from "../../components/General/Text";

const AccessibilityStatement = () => {
  return <Container>
    <Wrapper>
      <GeneralText variant='h1'>Accessibility statement for www.study.tech</GeneralText>

      <MrWrapper>
        <GeneralText variant='p'>
          This accessibility statement applies to the website www.study.tech <br />
          This website is run by Study Tech. We want as many people as possible to be able to use this website.
        </GeneralText>
      </MrWrapper>

      <MrWrapper>
        <GeneralText variant='p'>For example, that means you should be able to:</GeneralText>
      </MrWrapper>
      <MrWrapper>
        <ul>
          <li><GeneralText variant='p'>change colours, contrast levels and fonts using browser or device settings • zoom in up to 200% without the text spilling off the screen • navigate most of the website using a keyboard</GeneralText></li>
          <li><GeneralText variant='p'>navigate most of the website using speech recognition software</GeneralText></li>
          <li><GeneralText variant='p'>listen to most of the website using a screen reader (including the most recent versions of JAWS, NVDA and VoiceOver)</GeneralText></li>
        </ul>
      </MrWrapper>

      <MrWrapper>
        <GeneralText variant='p'>
          We’ve also made the website text as simple as possible to understand.<br />
          My Computer My Way has advice on making your device easier to use if you have a disability, and the AT Hive can help you find assistive technologies that work for you.
        </GeneralText>
      </MrWrapper>

      <GeneralText variant='pSemibold'>How accessible this website is</GeneralText>

      <MrWrapper>
        <GeneralText variant='p'>
          We’ve designed all pages of this website to be fully accessible and to meet the Web Content Accessibility Guidelines (WCAG) 2.2 AA standards.
        </GeneralText>
      </MrWrapper>

      <GeneralText variant='pSemibold'>Feedback and contact information</GeneralText>

      <MrWrapper>
        <GeneralText variant='p'>
          If you find any problems not listed on this page or think we’re not meeting accessibility requirements, contact: <a href='mailto:techsupport@study.tech' className="email-link">techsupport@study.tech</a> – our technical support team would be happy to help.
        </GeneralText>
      </MrWrapper>

      <MrWrapper>
        <GeneralText variant='p'>
          If you need information on this website in a different format like accessible PDF, large print, easy read, audio recording or braille:
        </GeneralText>
      </MrWrapper>

      <MrWrapper>
        <ul>
          <li><GeneralText variant='p'>email us at <a href='mailto:techsupport@study.tech' className="email-link">techsupport@study.tech</a></GeneralText></li>
          <li> <GeneralText variant='p'>call <GeneralText variant='pBoldUnderline'> 0204 532 2084</GeneralText></GeneralText></li>
        </ul>
        <br />
        <GeneralText variant='p'>We’ll review your request and get back to you in 5 working days.</GeneralText>
      </MrWrapper>

      <GeneralText variant='pSemibold'>Enforcement procedure</GeneralText>

      <MrWrapper>
        <GeneralText variant='p'>The Equality and Human Rights Commission (EHRC) is responsible for enforcing the Public Sector Bodies (Websites and Mobile Applications) (No. 2) Accessibility Regulations 2018 (the ‘accessibility regulations’). If you’re not happy with how we respond to your complaint, </GeneralText>
        <GeneralText variant='pBoldUnderline'>contact the Equality Advisory and Support Service (EASS).</GeneralText>
      </MrWrapper>

      <GeneralText variant='pSemibold'>Technical information about this website’s accessibility</GeneralText>
      <MrWrapper>
        <GeneralText variant='p'>Study Tech is committed to making its website accessible, in accordance with the Public Sector Bodies (Websites and Mobile Applications) (No. 2) Accessibility Regulations 2018.</GeneralText>
      </MrWrapper>

      <GeneralText variant='pSemibold'>Compliance status</GeneralText>

      <MrWrapper>
        <GeneralText variant='p'>The website has been tested against the Web Content Accessibility Guidelines (WCAG) 2.2 AA standard.</GeneralText><br />
        <GeneralText variant="p">This website is compliant with the</GeneralText> <GeneralText variant="pBoldUnderline">Web Content Accessibility Guidelines version 2.2 AA standard.</GeneralText>
      </MrWrapper>

      <GeneralText variant='pSemibold'>Non-accessible content</GeneralText>

      <MrWrapper>
        <GeneralText variant='p'>If you find an issue that we have yet to identify, please contact us using one of the routes described in the ‘Feedback and contact information’ section of this statement.</GeneralText>
      </MrWrapper>

      <GeneralText variant='pSemibold'>Disproportionate Burden</GeneralText>

      <MrWrapper>
        <GeneralText variant='p'>We are not currently claiming that any accessibility problems would be a disproportionate burden to fix.</GeneralText>
      </MrWrapper>

      <GeneralText variant='pSemibold'>Content that’s not within the scope of the accessibility regulations</GeneralText>

      <MrWrapper>
        <GeneralText variant='p'>At this time, we have not identified any content that is not within scope of the accessibility regulations.</GeneralText>
      </MrWrapper>

      <GeneralText variant='pSemibold'>Preparation of this accessibility statement</GeneralText>

      <MrWrapper>
        <GeneralText variant='p'>This statement was first prepared on 6 th February 2024. It was last reviewed on 25th February 2025.
          This website was last tested in December 2024. The test was carried out by All Able Ltd. A representative sample of pages of the website were tested. Testing was composed of a mixture of manual, semi-automated and assistive technology testing.</GeneralText>
      </MrWrapper>

      <GeneralText variant='pSemibold'>Accessibility test reports</GeneralText>

      <MrWrapper>
        <GeneralText variant='p'>Copies of the test reports are available upon request. Please contact us by email at <a href='mailto:techsupport@study.tech' className="email-link">techsupport@study.tech</a> to request a copy.</GeneralText>
      </MrWrapper>

    </Wrapper>
  </Container>;
};

export default AccessibilityStatement;
